import type { ContractData } from '@/api/contract/types';
import type { ContractItem } from '@/ContractConfig';
import type { CommodityPo } from '@/po/commodity';
import type { commodityModelItemType } from '@/api/preApplyChoose/types';

/** 可授信渠道列表 */
export interface ApplyChooseList {
  // 任务ID
  taskId: string;
  // 商品列表信息
  commoditys: CommodityPo.Info[];
  /** 是否是从首页来的老的存量用户标识
   * 通过接口实时查询发现用户非实时存量用户
   * 跳转到列表贷超带上这个标识 */
  isStock: boolean;
  /** 查询到的 commoditys 列表 是否是 存量渠道列表，默认false */
  isStockChannel: boolean;
  /** 是否是自营圈选中的用户 */
  autarky: boolean;
  /** 本次是否为自营B的分发 */
  filterType?: string;
  applyMode: ApplyModeEnum;
  dispatchBatchNo: string; // 流量分发批次号，需要传入授信申请接口
  /** 透传参数 */
  extra: Record<string, unknown>;
  /** 是否是大盘新客 */
  newCustomer?: boolean;
  /** 预授信分发条件，需要达成 查看协议的最短时长(单位：秒) */
  preCreditDelayTime?: number;
  /** 是否继续轻资产渠道分发 */
  continueLightDispatch?: boolean;
}

export interface AgreementItem {
  name: string;
  id: string | number;
}

export interface StateType {
  // 多渠道信息
  applyChooseList: ApplyChooseList | null;
  // 贷超半流程授信有授信渠道返回为true
  isDcHalfApply: false,
  // 渠道协议信息
  agreements: ContractData[] | ContractItem[];
  /** 征信渠道id */
  creditRouteChannel?: string,
  /** 授信提交渠道id  不删除是因为后端一些老逻辑还在依赖这个字段 */
  submitCommodityIds: number[],
  /** 授信提交渠道id&渠道申请模式 */
  commodityModelList: commodityModelItemType[],
}

export enum PreApplyPageTypeEnum {
  normal, // 普通用户
  autarky, // 自营升级用户
  dcHalf, // 贷超半流程用户
}

/** 授信申请模式 */
export enum ApplyModeEnum {
  /** 串行  */
  serial = 'serial',
  /** 并行 */
  parallel = 'parallel',
  /** 串行+并行 */
  mix = 'mix',
}

/** 协议曝光数据 */
export interface ProtocolExposeDataType {
  supplierCode: number;
  agreementName: string;
  commodityId: number;
  commodityName: string;
  position: number;
}
